import(/* webpackMode: "eager" */ "/home/boymep/danilpanov/src/app/[locale]/page.tsx");
